import { computed } from 'vue'
import { useStore } from 'vuex'

/**
 * Composable for accessing point system feature flag status
 * and providing conditional rendering helpers
 */
export function usePointSystem() {
    const store = useStore()

    // Get current point system control flag
    const pointControlFlag = computed(() =>
        store.state.FeatureFlag?.pointControl?.flag || 'DECENTRALIZE'
    )

    // Check if feature flag data is actually loaded
    const isFeatureFlagLoaded = computed(() =>
        store.state.FeatureFlag?.pointControl !== null && store.state.FeatureFlag?.pointControl !== undefined
    )

    // Get metadata
    const metadata = computed(() =>
        store.state.FeatureFlag?.pointControl?.metadata || {}
    )

    // Check merchant can see Point Plan menu on DECENTRALIZE mode
    const showMerchantPointPlan = computed(() =>
        pointControlFlag.value === 'DECENTRALIZE'
    )

    // Check corporate can see Point Plan menu/settings on CENTRALIZE mode
    const showCorporatePointPlan = computed(() =>
        pointControlFlag.value === 'CENTRALIZE'
    )

    // Check point system is not NONACTIVE
    const isPointSystemActive = computed(() =>
        pointControlFlag.value !== 'NONACTIVE'
    )

    // Check point value enabled
    const isPointValueEnabled = computed(() =>
        metadata.value?.point_value_enabled === true || metadata.value?.point_value_enabled === 1
    )

    // Check point value is visible to members (both enabled AND visible toggle must be on)
    const isPointValueVisibleToMember = computed(() =>
        isPointValueEnabled.value &&
        (metadata.value?.point_value_visible_to_member === true || metadata.value?.point_value_visible_to_member === 1)
    )

    // Get point value rate
    const pointValueRate = computed(() =>
        metadata.value?.point_value_rate || 0
    )

    // Check corporate can access Inject Point on CENTRALIZE mode
    const showCorporateInjectPoint = computed(() =>
        pointControlFlag.value === 'CENTRALIZE'
    )

    // Check merchant can access Inject Point on DECENTRALIZE mode
    const showMerchantInjectPoint = computed(() =>
        pointControlFlag.value === 'DECENTRALIZE'
    )

    return {
        pointControlFlag,
        isFeatureFlagLoaded,
        metadata,
        showMerchantPointPlan,
        showCorporatePointPlan,
        showCorporateInjectPoint,
        showMerchantInjectPoint,
        isPointSystemActive,
        isPointValueEnabled,
        isPointValueVisibleToMember,
        pointValueRate
    }
}
